const config = {
  name: "manor-vail",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: false,
    userPostalCode: false
  },
  parkingSession: {
    // Until 7 AM the day before (24 hours before)
    cancelDaysBefore: 1,
    cancelTime: "07:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 7 am
    startOffsetHrs: 7,
    // Start date offset from today (0 = today)
    startOffsetDate: 1,
    // End date offset from start time
    endOffsetDate: 30
  }
}
export default config
